export type FieldClock = Record<string, string>;

// 时间戳比较必须按真实时刻（epoch ms），不能直接字符串比较：protocol 的 client_ts 允许
// 带偏移（z.string().datetime({ offset: true })），例如移动端可能发 "...+09:00"。
// 字符串 "...+09:00"（更早的时刻）会 > "...Z"（更晚的时刻），导致 LWW 保留旧值丢掉新值。
// 解析失败时退回字符串比较（保持原有确定性，不让脏数据炸掉合并）。
// 导出供 sync-push 的删除权威性（__deleted__ vs upsert client_ts）复用同一套 offset-aware 比较。
export function isNewer(incomingTs: string, existing: string): boolean {
  const a = Date.parse(incomingTs);
  const b = Date.parse(existing);
  if (Number.isNaN(a) || Number.isNaN(b)) return incomingTs > existing;
  return a > b;
}

export function applyFieldClock(
  currentClock: FieldClock,
  incomingFields: Record<string, unknown>,
  incomingTs: string,
): {
  acceptedFields: Record<string, unknown>;
  nextClock: FieldClock;
} {
  const acceptedFields: Record<string, unknown> = {};
  const nextClock: FieldClock = { ...currentClock };

  for (const [key, value] of Object.entries(incomingFields)) {
    const existing = currentClock[key];
    if (existing === undefined || isNewer(incomingTs, existing)) {
      acceptedFields[key] = value;
      nextClock[key] = incomingTs;
    }
  }

  return { acceptedFields, nextClock };
}

export function mergeFieldClocks(a: FieldClock, b: FieldClock): FieldClock {
  const out: FieldClock = { ...a };
  for (const [key, ts] of Object.entries(b)) {
    const existing = out[key];
    if (existing === undefined || isNewer(ts, existing)) out[key] = ts;
  }
  return out;
}
